module.exports = __webpack_public_path__ + "img/logo-white.7da778c7.svg";